import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getDesignerTape } from '../../../helpers/designerTape';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  designerTape: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (designerTape, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      designerTape,
    },
  });

export const DesignerTape = () => {
  const [state, send] = useService(productBuilderMachine);
  const { designerTape } = state.context.custom;

  const designerTapeOptions = getDesignerTape(state.context);

  if (
    isCurrentState('designerTape', state) &&
    designerTapeOptions.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <h1>Designer Tape</h1>
      <Selector>
        {designerTapeOptions.map(option => {
          const isSelected = option === designerTape;
          return (
            <SelectorItem
              isSelected={isSelected}
              onClick={onClick(option, send)}
              key={option}
            >
              {option}
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
